module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Counter_PeriodicallUpdater', {

		configure: function(options) {
			this.registerOptions('', {
				updateTime: 15000,				
				handleWom: {
					'navigator': {
						'event': 'modified_0',
						widget: fox.Navigator,
						callback: '@this:touchUpdate',
					}
				}
			});
			this.callParent('configure', arguments);
		},

		running: function() {
			this.touchUpdate();
			this.callParent('running', arguments);
		},

		touchUpdate: function() {
			if (fox.site.member && !this.isStarted()) {
				this.startUpdate();
			}
		}

	}, 'PeriodicalUpdater');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/chat/widget/conversation/counterPeriodicalUpdater.js
// module id = 87
// module chunks = 4